import React from "react";
// import HoldingPage from "../app-template/holding";
import { FolioCabin } from "../app-template/AppContent";
import CabinContent from "./CabinContent";
import IconFaClose from "../img/IconFaClose";
import IconFaQuoteLeft from "../img/IconFaQuoteLeft";
import IconFaQuoteRight from "../img/IconFaQuoteRight";
import IconFaMobile from "../img/IconFaMobile";
import IconFaTablet from "../img/IconFaTablet";
import IconFaDesktop from "../img/IconFaDesktop";
import IconFaCheck from "../img/IconFaCheck";
import IconFaMinus from "../img/IconFaMinus";
import CabinUserFlow from "./img/cs-flow-diagram.svg";
import IdeationStickies from "./img/ideation-user-groups.jpg";
import IdeationSketches from "./img/ideation-sketching.jpg";
import PrototypeScreen01 from "./img/prototype/screen01.png";
import PrototypeScreen02 from "./img/prototype/screen02.png";
import PrototypeScreen03 from "./img/prototype/screen03.png";
import PrototypeScreen04 from "./img/prototype/screen04.png";
import PrototypeScreen05 from "./img/prototype/screen05.png";
import PrototypeScreen06 from "./img/prototype/screen06.png";
import CruiseEvent from "./img/cruise-event.jpg";
import KanoChart from "./img/cs-chart-desire-feasible.png";
import DesignScreen01 from "./img/design01/screen01.png";
import DesignScreen02 from "./img/design01/screen06.png";
import DesignScreen03 from "./img/design01/screen10.png";
import DesignScreen04 from "./img/design01/screen12.png";
import DesignScreen05 from "./img/design01/screen15.png";
import DesignMobile from "./img/design01/mobile.png";
import Design02Large01 from "./img/design02/large-screen01.png";
import Design02Large02 from "./img/design02/large-screen02.png";
import Design02Small01 from "./img/design02/small-screen01.png";
import Design02Small02 from "./img/design02/small-screen02.png";

// (function Parallax() {
//   let intro = document.querySelector(".intro-block");
//   const parallax = intro.dataset.parallax;
//   console.log(parallax);
//   const elementClasses = elementNodeReference.classList;
//   window.addEventListener("scroll", () => {
//     let yPos = document.querySelector(".parallax");
//     let offset = window.pageYOffset;
//     yPos.style.backgroundPositionY = offset * 0.4 + "px";
//   });
// })();

function CabinSelectView() {
	window.scrollTo(0, 0); // scroll to top of page

	return (
		<article className="case-study folio-cabin">
			{/* header */}
			<section className="intro-block" data-parallax="true">
				<span className="inner">
					<span className="title-block">
						<h2 className="title">{FolioCabin.caseStudy}</h2>
						<ul className="tag-list">
							<li className="tag">{FolioCabin.tag01}</li>
							<li className="tag">{FolioCabin.tag02}</li>
						</ul>
					</span>
				</span>
			</section>
			{/* introduction */}
			<section className="text-block">
				<h3 className="title">{CabinContent.introduction.heading}</h3>
				{CabinContent.introduction.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
			</section>
			{/* problems */}
			<section className="text-block">
				<h3 className="title">{CabinContent.problems.heading}</h3>
				{CabinContent.problems.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
				<ul className="list">
					{CabinContent.problems.list.map((item) => {
						return (
							<li className="list-item withIcon">
								<IconFaClose />
								{item}
							</li>
						);
					})}
				</ul>
			</section>
			{/* pullquote 01 */}
			<blockquote className="pullquote">
				<span className="quote">
					<IconFaQuoteLeft />
					{CabinContent.pullquote.quote}
					<IconFaQuoteRight />
				</span>
				<span className="caption">{CabinContent.pullquote.caption}</span>
				<ul className="list">
					{CabinContent.pullquote.list.map((item) => {
						return <li className="list-item">{item}</li>;
					})}
				</ul>
			</blockquote>
			{/* existing user-flow */}
			<section className="text-block">
				<h3 className="title">{CabinContent.existingUserFlow.heading}</h3>
				{CabinContent.existingUserFlow.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
			</section>
			<figure className="image-block cs-userflow">
				<img src={CabinUserFlow} alt="Cabin selection user flow" />
			</figure>
			{/* ideation */}
			<section className="text-block">
				<h3 className="title">{CabinContent.ideation.heading}</h3>
				{CabinContent.ideation.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
				<ul className="list">
					{CabinContent.ideation.list.map((item) => {
						return <li className="list-item">{item}</li>;
					})}
				</ul>
			</section>
			<figure className="image-block cs-ideation">
				<span className="image">
					<img src={IdeationStickies} alt="Ideation session user groups" />
				</span>
				<span className="image">
					<img src={IdeationSketches} alt="Ideation session sketching" />
				</span>
			</figure>
			{/* geurilla test */}
			<section className="text-block">
				<h3 className="title">{CabinContent.geurillaTest.heading}</h3>
				{CabinContent.geurillaTest.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
			</section>
			{/* prototype screens */}
			<figure className="prototype-block">
				<ul className="prototype-list cs-prototype">
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={PrototypeScreen01} alt="Prototype screen 01" />
						</span>
						<span className="caption">
							{CabinContent.prototypeCaptions.screen01}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={PrototypeScreen02} alt="Prototype screen 02" />
						</span>
						<span className="caption">
							{CabinContent.prototypeCaptions.screen02}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={PrototypeScreen03} alt="Prototype screen 03" />
						</span>
						<span className="caption">
							{CabinContent.prototypeCaptions.screen03}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={PrototypeScreen04} alt="Prototype screen 04" />
						</span>
						<span className="caption">
							{CabinContent.prototypeCaptions.screen04}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={PrototypeScreen05} alt="Prototype screen 05" />
						</span>
						<span className="caption">
							{CabinContent.prototypeCaptions.screen05}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={PrototypeScreen06} alt="Prototype screen 06" />
						</span>
						<span className="caption">
							{CabinContent.prototypeCaptions.screen06}
						</span>
					</li>
				</ul>
			</figure>
			{/* cruise event */}
			<figure className="cs-cruise-show">
				<img src={CruiseEvent} alt="Cruise event" />
				<figcaption className="caption">
					{CabinContent.cruiseEventCaption}
				</figcaption>
			</figure>
			{/* Kano chart - desirability vs feasability */}
			<section className="text-block">
				<h3 className="title">{CabinContent.kanoChart.heading}</h3>
				{CabinContent.kanoChart.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
			</section>
			<figure className="image-block cs-chart">
				<span className="image">
					<img src={KanoChart} alt="Chart of feasible and desirable features" />
				</span>
			</figure>
			{/* design v1 */}
			<section className="text-block">
				<h3 className="title">{CabinContent.designV1.heading}</h3>
				{CabinContent.designV1.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
			</section>
			{/* design v1 screens */}
			<figure className="prototype-block">
				<ul className="prototype-list cs-designV1">
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={DesignScreen01} alt="Prototype screen 01" />
						</span>
						<span className="caption">
							{CabinContent.designV1Captions.screen01}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={DesignScreen02} alt="Prototype screen 02" />
						</span>
						<span className="caption">
							{CabinContent.designV1Captions.screen02}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={DesignScreen03} alt="Prototype screen 03" />
						</span>
						<span className="caption">
							{CabinContent.designV1Captions.screen03}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={DesignScreen04} alt="Prototype screen 04" />
						</span>
						<span className="caption">
							{CabinContent.designV1Captions.screen04}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img src={DesignScreen05} alt="Prototype screen 05" />
						</span>
						<span className="caption">
							{CabinContent.designV1Captions.screen05}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen mobile">
							<img src={DesignMobile} alt="Prototype screen 05" />
						</span>
						<span className="caption">
							{CabinContent.designV1Captions.screen05}
						</span>
					</li>
				</ul>
			</figure>
			{/* pullquote 02 */}
			<blockquote className="pullquote">
				<span className="quote">
					<IconFaQuoteLeft />
					{CabinContent.pullquote02.quote}
					<IconFaQuoteRight />
				</span>
				<span className="caption">{CabinContent.pullquote02.caption}</span>
				<ul className="list">
					{CabinContent.pullquote02.list.map((item) => {
						return <li className="list-item">{item}</li>;
					})}
				</ul>
			</blockquote>
			{/* A failed experiment */}
			<section className="text-block">
				<h3 className="title">{CabinContent.designFail.heading}</h3>
				{CabinContent.designFail.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
			</section>
			{/* design v2 */}
			<section className="text-block">
				<h3 className="title">{CabinContent.designV2.heading}</h3>
				{CabinContent.designV2.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
			</section>
			{/* design v2 screens */}
			<figure className="prototype-block">
				<ul className="prototype-list cs-designV2 ">
					<li className="prototype-item">
						<span className="prototype-screen">
							<img
								src={Design02Large01}
								alt="Second design iteration large screen"
							/>
						</span>
						<span className="caption">
							{CabinContent.designV2Captions.screen01}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img
								src={Design02Large02}
								alt="Second design iteration large screen"
							/>
						</span>
						<span className="caption">
							{CabinContent.designV2Captions.screen02}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img
								src={Design02Small01}
								alt="Second design iteration small view"
							/>
						</span>
						<span className="caption">
							{CabinContent.designV2Captions.screen03}
						</span>
					</li>
					<li className="prototype-item">
						<span className="prototype-screen">
							<img
								src={Design02Small02}
								alt="Second design iteration small view"
							/>
						</span>
						<span className="caption">
							{CabinContent.designV2Captions.screen04}
						</span>
					</li>
				</ul>
			</figure>
			{/* Results */}
			<section className="text-block">
				<h3 className="title">{CabinContent.experimentResults.heading}</h3>
				{CabinContent.experimentResults.paras.map((para) => {
					return <p className="para">{para}</p>;
				})}
				<figure className="table-block">
					<table className="insights-table">
						<thead>
							<tr>
								<th>Key Performance Indicator</th>
								<th>
									<IconFaMobile aria-hidden="true" /> Mobile
								</th>
								<th>
									<IconFaTablet aria-hidden="true" /> Tablet
								</th>
								<th>
									<IconFaDesktop aria-hidden="true" /> Desktop
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Online Bookings</td>
								<td>
									<IconFaCheck aria-hidden="true" />
									<span class="kpi-negative">Positive</span>
								</td>
								<td>
									<IconFaCheck aria-hidden="true" />
									<span class="kpi-negative">Positive</span>
								</td>
								<td>
									<IconFaCheck aria-hidden="true" />
									<span class="kpi-negative">Positive</span>
								</td>
							</tr>
							<tr>
								<td>Phone Enquiries</td>
								<td>
									<IconFaCheck aria-hidden="true" /> Positive
								</td>
								<td>
									<IconFaMinus aria-hidden="true" /> Neutral
								</td>
								<td>
									<IconFaCheck aria-hidden="true" /> Positive
								</td>
							</tr>
							<tr>
								<td>Email Enquiries</td>
								<td>
									<IconFaMinus aria-hidden="true" /> Neutral
								</td>
								<td>
									<IconFaMinus aria-hidden="true" /> Neutral
								</td>

								<td>
									<IconFaCheck aria-hidden="true" /> Positive
								</td>
							</tr>
						</tbody>
					</table>
				</figure>
			</section>
		</article>
	);
}

export default CabinSelectView;
